<main class="landing-screen">
  <img class="background-image" [src]="backgroundImageUrl" alt="Background" />
  @if (bursaryFunds && bursaryFunds.length) {
    <section class="content">
      <h1>Bursary funds</h1>
      <section class="bursary-funds-grid">
        @for (fund of bursaryFunds; track fund) {
          <app-bursary-fund-card [fund]="fund"></app-bursary-fund-card>
        }
      </section>
      <section class="bursary-reporting-wrapper">
        <app-bursary-reporting
          [fundSpending]="fundSpending"
          [universitySpending]="universitySpending"
          [fundSpendingTotal]="fundSpendingTotal"
          [universitySpendingTotal]="universitySpendingTotal"
        ></app-bursary-reporting>
      </section>
    </section>
  } @else {}
</main>
